import PropTypes from 'prop-types';
import Image from 'next/image';
import CustomRater from './CustomRater';
import MillesimaLink from './MillesimaLink';

import styles from './TrustedBadge.module.scss';
import { RATING_TOTAL } from '@/constants/trustedBadgeRating';
import { URLS } from '@/constants/urls';

const TrustedBadge = ({
  trustLink, ratingValue, isSmallImg = false, isWhiteImg = false, isSmallText = false, isGreyBackground = false, fontColor
}) => {
  const linkClassName = [
    styles.link,
    isSmallImg ? styles.small : '',
    isWhiteImg ? styles['trusted-white'] : '',
    isGreyBackground ? styles['grey-background'] : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={styles.container} data-test-id="trusted-badge">
      <MillesimaLink
        href={trustLink || '#'}
        target="_blank"
        ariaLabel="TrustMark"
        isTargetBlank
        isNofollow
        customClassName={{ container: linkClassName }}
      >
        <div className={styles['trusted-image-rater']}>
          {isSmallImg ? (
            <Image
              src={URLS[`TRUSTEDSHOP${isWhiteImg ? '_WHITE' : '_BLACK'}`]}
              className={styles['trusted-image-small']}
              alt="TrustMark"
              height={27}
              width={65}
            />
          ) : (
            <img
              src={URLS.TRUSTEDSHOP_IMAGE}
              className={styles['trusted-image']}
              alt="TrustMark"
              height={32}
              width={32}
              loading="lazy"
              data-test-id="custom-img"
            />
          )}
          <div className={`${styles['trusted-badge-right']} ${isSmallImg ? '' : styles['not-small']}`}>
            <div className={styles['trusted-rater']}>
              <CustomRater rating={ratingValue} />
            </div>
            <div className={`${styles['trusted-rating']} ${isSmallText ? styles['trusted-rating-small'] : ''}`} data-test-id="trusted-rating" style={{ color: fontColor }}>
              <span className={styles['trusted-note']}>{ratingValue}</span>/{RATING_TOTAL}
            </div>
          </div>
        </div>
      </MillesimaLink>
    </div>
  );
};

TrustedBadge.propTypes = {
  ratingValue: PropTypes.number.isRequired,
  trustLink: PropTypes.string,
  isSmallImg: PropTypes.bool,
  isWhiteImg: PropTypes.bool,
  isSmallText: PropTypes.bool,
  isGreyBackground: PropTypes.bool,
  fontColor: PropTypes.string
};

export default TrustedBadge;
